import { motion } from "framer-motion";
import Button from "./Button";
import { brand, images } from "../data/siteData";

export default function CTASection() {
  return (
    <section className="cta-band" style={{ "--cta-image": `url(${images.detail})` }}>
      <motion.div
        className="container cta-inner"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.35 }}
        transition={{ duration: 0.55 }}
      >
        <span className="eyebrow">Launch offer</span>
        <h2>Ready to stop guessing and start building?</h2>
        <p>Secure your copy of {brand.productName} and start applying a cleaner nutrition system today.</p>
        <div className="cta-price">
          <s>{brand.oldPrice}</s>
          <strong>{brand.price}</strong>
        </div>
        <Button to="/checkout">Buy Now</Button>
      </motion.div>
    </section>
  );
}
